// Utilities
import Logger from '../../utility/loggerUtil'

import { BrowserType, OsType } from '../../constants'

export default {
  async promptPwaChromeInstall (context) {
    try {
      if (context.state.pwaDeferredPrompt === undefined) {
        Logger.debug('No deferred prompt to open')
        return
      }

      context.state.pwaDeferredPrompt.prompt()

      Logger.debug('Prompt executed')

      const { outcome } = await context.state.pwaDeferredPrompt.userChoice

      Logger.info(`Installation outcome: ${outcome}`)
    } catch (e) {
      Logger.error('Error showing installation prompt')
      Logger.debug(e)
      throw e
    }
  },

  async getSupportsPwa (context) {
    if (context.state.isPwa) {
      return false
    }

    if (context.state.supportsPwaPrompt) { // If the browser supports PWA prompt, use Chrome instructions
      return true
    }

    if (context.state.isMobileBrowser && context.state.mobileOs === OsType.Apple && context.state.browserType === BrowserType.Safari) { // Safari is only supported browser on iOS
      return true
    }
  }
}
